import { createContext } from "react";

const AssessmentContext = createContext();

export default AssessmentContext;
